import React, { Component } from 'react';
import Table from '../components/settings/Plans/Index'
import WebpackerReact from 'webpacker-react';

class PlanIndex extends Component {
    constructor(props) {
        super(props);
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            data: [],
            isLoaded: true,
        }
    }

    componentDidMount(){
        this.loadData();
    }

    updateStateLoad = (state) => {
        this.setState({ isLoaded: state })
    } 

    //add items
    updateData = (data) => {
        this.setState({
            data: [...this.state.data, data],
        })
    }

    //add update
    updateItem = plan => {
        this.setState({
            data: this.state.data.map(item => {
            if (plan.id === item.id) {
              return { ...item, 
                name: plan.name,
                users_plan: plan.users_plan, 
                size_plan: plan.size_plan,
              }
            }
            return item;
          })
        });
    }

    loadData = () => {
        fetch(`/settings/get_plans`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
          this.setState({
            data: data.data,
            isLoaded: false
          });
        });
    }


    render() {
        return (
            <React.Fragment>
                <Table
                    updateStateLoad={this.updateStateLoad}
                    loadData={this.loadData}
                    data={this.state.data}
                    isLoaded={this.state.isLoaded}
                    updateItem={this.updateItem}
                    updateData={this.updateData}
                />
            </React.Fragment>
        );
    }
}


export default PlanIndex;
WebpackerReact.setup({ PlanIndex });

